import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import AnalysisResult from "@/components/AnalysisResult";
import { Button } from "@/components/ui/button";
import { Loader2, ArrowRight } from "lucide-react";

export default function PublicReport() {
  const { token } = useParams();
  const [report, setReport] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    api
      .get(`/public/reports/${token}`)
      .then((r) => setReport(r.data))
      .catch((e) => setError(e.response?.data?.detail || "This report is not available."));
  }, [token]);

  return (
    <div className="min-h-screen bg-[#F9F9FA]">
      <header className="h-16 bg-white/80 backdrop-blur-xl border-b border-gray-200 sticky top-0 z-40 flex items-center justify-between px-6">
        <Link to="/" className="flex items-center gap-2">
          <img src="/logo.png" alt="Sapientia" className="w-8 h-8 object-contain" />
          <span className="font-heading font-black text-xl tracking-tighter">Sapientia</span>
        </Link>
        <Link to="/register">
          <Button className="bg-[#0A0A0A] hover:bg-gray-800" data-testid="public-cta">
            Run your own audit <ArrowRight className="w-4 h-4 ml-2" />
          </Button>
        </Link>
      </header>

      <main className="p-6 md:p-8 lg:p-10 max-w-6xl mx-auto">
        {error ? (
          <div className="text-center pt-24" data-testid="public-report-error">
            <h1 className="font-heading text-3xl font-black tracking-tighter">Report unavailable</h1>
            <p className="text-gray-500 mt-2">{error}</p>
            <Link to="/">
              <Button className="mt-6 bg-[#0A0A0A] hover:bg-gray-800">Go to Sapientia</Button>
            </Link>
          </div>
        ) : !report ? (
          <div className="flex justify-center pt-24">
            <Loader2 className="w-8 h-8 animate-spin text-klein" />
          </div>
        ) : (
          <>
            <div className="mb-6">
              <span className="uppercase-label">Shared SEO Report</span>
              <h1 className="font-heading text-3xl sm:text-4xl font-black tracking-tighter mt-1">
                Website Audit
              </h1>
            </div>
            <AnalysisResult report={report} />
          </>
        )}
      </main>
    </div>
  );
}
